module.exports = __webpack_public_path__ + "img/ico-security-red.0ba4cae9.svg";